import { DesignerV2API } from '@newo/api/gateway';

import axios from '@/utils/api/axiosInstance';

export const designerV2API = new DesignerV2API(axios);
